export const SPORT_STATS_CONFIG = {
    "Basquetebol": {
        type: "score",
        label: "Pontos",
        stats: [
            { key: "points", label: "Pontos", unit: "pts", inputType: "number" },
            { key: "rebounds", label: "Ressaltos", unit: "reb", inputType: "number" },
            { key: "assists", label: "Assistências", unit: "ast", inputType: "number" },
            { key: "steals", label: "Roubos", unit: "", inputType: "number" },
            { key: "blocks", label: "Blocos", unit: "", inputType: "number" },
            { key: "fouls", label: "Faltas", unit: "", inputType: "number" },
            { key: "threePointers", label: "Triplos", unit: "", inputType: "number" },
            { key: "minutesPlayed", label: "Minutos", unit: "min", inputType: "number" },
        ]
    },
    "Futsal": {
        type: "score",
        label: "Golos",
        stats: [
            { key: "goals", label: "Golos", unit: "", inputType: "number" },
            { key: "assists", label: "Assistências", unit: "", inputType: "number" },
            { key: "saves", label: "Defesas (GR)", unit: "", inputType: "number" },
            { key: "yellowCards", label: "Cartões Am.", unit: "", inputType: "number" },
            { key: "redCards", label: "Cartões Verm.", unit: "", inputType: "number" },
            { key: "minutesPlayed", label: "Minutos", unit: "min", inputType: "number" },
        ]
    },
    "Hóquei em Patins": {
        type: "score",
        label: "Golos",
        stats: [
            { key: "goals", label: "Golos", unit: "", inputType: "number" },
            { key: "assists", label: "Assistências", unit: "", inputType: "number" },
            { key: "saves", label: "Defesas (GR)", unit: "", inputType: "number" },
            { key: "blueCards", label: "Cartões Azuis", unit: "", inputType: "number" },
            { key: "redCards", label: "Cartões Verm.", unit: "", inputType: "number" },
            { key: "minutesPlayed", label: "Minutos", unit: "min", inputType: "number" },
        ]
    },
    "Voleibol": {
        type: "sets",
        maxSets: 5,
        label: "Sets",
        stats: [
            { key: "points", label: "Pontos", unit: "pts", inputType: "number" },
            { key: "aces", label: "Aces", unit: "", inputType: "number" },
            { key: "blocks", label: "Blocos", unit: "", inputType: "number" },
            { key: "spikes", label: "Ataques", unit: "", inputType: "number" },
            { key: "receptions", label: "Receções", unit: "", inputType: "number" },
            { key: "errors", label: "Erros", unit: "", inputType: "number" },
        ]
    },
    "Badminton": {
        type: "sets",
        maxSets: 3,
        label: "Sets",
        stats: [
            { key: "setsWon", label: "Sets Ganhos", unit: "", inputType: "number" },
            { key: "points", label: "Pontos Totais", unit: "pts", inputType: "number" },
        ]
    },
    "Ténis de Mesa": {
        type: "sets",
        maxSets: 7,
        label: "Sets",
        stats: [
            { key: "setsWon", label: "Sets Ganhos", unit: "", inputType: "number" },
            { key: "points", label: "Pontos Totais", unit: "pts", inputType: "number" },
        ]
    },
    "Atletismo": {
        type: "individual",
        label: "Individual",
        stats: [
            { key: "event", label: "Prova", unit: "", inputType: "text" },
            { key: "result", label: "Resultado", unit: "", inputType: "text", placeholder: "ex: 10.54s / 7.45m" },
            { key: "position", label: "Classificação", unit: "º", inputType: "number" },
            { key: "personalBest", label: "Record Pessoal", unit: "", inputType: "checkbox" },
        ]
    }
};

const normalizeSportName = (name) => (name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

const SPORT_ALIASES = { volei: 'Voleibol', volley: 'Voleibol' };

function findSportKey(sportName) {
    const normalized = normalizeSportName(sportName);
    if (!normalized) return null;
    const keys = Object.keys(SPORT_STATS_CONFIG);
    const exact = keys.find(k => normalizeSportName(k) === normalized);
    if (exact) return exact;
    const partial = keys.find(k => normalized.includes(normalizeSportName(k)));
    if (partial) return partial;
    const alias = Object.keys(SPORT_ALIASES).find(a => normalized.includes(a));
    return alias ? SPORT_ALIASES[alias] : null;
}

/** Accepts several candidate names; the first one that matches a known sport wins. */
export function getSportConfig(...sportNames) {
    for (const name of sportNames) {
        const key = findSportKey(name);
        if (key) return SPORT_STATS_CONFIG[key];
    }
    return getDefaultConfig();
}

function getDefaultConfig() {
    return {
        type: "score",
        label: "Pontos",
        stats: [
            { key: "goals", label: "Golos", unit: "", inputType: "number" },
            { key: "minutesPlayed", label: "Minutos", unit: "min", inputType: "number" },
        ]
    };
}

export function calculateSetScore(sets) {
    if (!sets || sets.length === 0) return { homeSets: 0, awaySets: 0 };
    let homeSets = 0;
    let awaySets = 0;
    sets.forEach(s => {
        if (s.home > s.away) homeSets++;
        else if (s.away > s.home) awaySets++;
    });
    return { homeSets, awaySets };
}
